module.exports = __webpack_public_path__ + "static/media/urban-lives.d2204a22.png";